export { Extended, ExtendedText, ExtendedButton } from './Extended';
export { ExtendedTextSlot, ExtendedButtonSlot, ExtendedHeader, ExtendedHeaderSup, ExtendedStoryLink } from './Extended.views';